import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.element.classList.add('is-in-viewport');
            return;
        }

        requestAnimationFrame(() => {
            this.setupEntranceAnimation();
        });
    }

    disconnect() {
        this.entranceObserver?.disconnect();
    }

    setupEntranceAnimation() {
        if (!('IntersectionObserver' in window)) {
            this.element.classList.add('is-in-viewport');
            return;
        }

        this.entranceObserver = new IntersectionObserver(
            (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) {
                    return;
                }

                requestAnimationFrame(() => {
                    this.element.classList.add('is-in-viewport');
                    this.entranceObserver.disconnect();
                });
            },
            {
                rootMargin: '0px 0px -10% 0px',
                threshold: 0.15,
            },
        );

        this.entranceObserver.observe(this.element);
    }
}
